<template>
  <div class="sequence-call-action-container">
    <BDrawerMenu
      v-if="sequenceStep"
      v-model="internalIsOpen"
      :title="$t('sequence.step.types.callAction')"
      @cancel="handleDrawerCancel"
    >
      <div
        v-if="doneAt"
        class="time-items"
      >
        <BListItem class="mb-300">
          <template #header>
            <span>{{ $t('nextAction.doneAt') }}</span>
          </template>
          <div class="mt-100">
            {{ doneAt }}
          </div>
        </BListItem>
      </div>
      <BListItem class="mb-300">
        <template #header>
          <span>{{ $t('sequence.nextAction.nextActionContent') }}</span>
        </template>
        <div class="mt-100 call-action-content">
          {{ sequenceStep.nextActionContent }}
        </div>
      </BListItem>
    </BDrawerMenu>
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, ref, watch } from 'vue';
import { formatDateTime } from '@/utils/date-time';
import { TPartialFormCallActionSequenceStep } from './types';

type TProps = {
  sequenceStep?: TPartialFormCallActionSequenceStep;
  isOpen?: boolean;
};
type TEmits = {
  'click:cancel': [];
};

const props = withDefaults(defineProps<TProps>(), {
  sequenceStep: null,
  isOpen: false,
});
const emit = defineEmits<TEmits>();
const internalIsOpen = ref(props.isOpen);

const doneAt = computed<string>(() => {
  return formatDateTime(props.sequenceStep?.doneAt);
});

watch(() => props.isOpen, (newValue) => {
  nextTick(() => {
    internalIsOpen.value = newValue;
  });
});

const handleDrawerCancel = () => {
  emit('click:cancel');
};
</script>

<style lang="scss" scoped>
.sequence-call-action-container {
  position: relative;
  height: 100%;

  .time-items {
    display: flex;
    gap: 10px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .footer {
    padding: 0 20px;
    height: 48px;
    background-color: $bgcolor-dark;
    display: flex;
  }

  .call-action-content {
    white-space: pre-wrap;
  }
}
</style>
